var map = {
	"./10ans.png": 333,
	"./11ans.png": 334,
	"./12ans.png": 335,
	"./3ans.png": 336,
	"./4ans.png": 337,
	"./5ans.png": 338,
	"./6ans.png": 339,
	"./7ans.png": 340,
	"./8ans.png": 341,
	"./9ans.png": 342
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 332;